module.exports = __webpack_public_path__ + "media/images/greeting-e9c0b5a2.png";